import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import React, { useState } from 'react';
import parse from 'html-react-parser';
import Modal from '@amzn/meridian/modal';
import { InfoIcon } from 'src/common/icons';
import { usePageContext } from 'src/hooks';
import { RioText } from 'src/common/styled/StyledComponets';
import { RetailRoutes, useRetailRedirectUrls } from 'src/utils/links';
export const PricePopoverModal = ({ price }) => {
    var _a;
    const [isPriceModalOpen, setPriceModalOpen] = useState(false);
    const { bundle } = usePageContext();
    const redirectUrls = useRetailRedirectUrls([RetailRoutes.REFERENCE_PRICE_AND_SAVINGS]);
    // Replace any href links in the popover HTML with the localized reference price help page URL
    const popoverContent = (price === null || price === void 0 ? void 0 : price.popoverContent)
        ? (_a = price === null || price === void 0 ? void 0 : price.popoverContent) === null || _a === void 0 ? void 0 : _a.replace(/href="([^"]*)"/g, `href="${redirectUrls.REFERENCE_PRICE_AND_SAVINGS}"`)
        : price === null || price === void 0 ? void 0 : price.popoverContent;
    if (!popoverContent)
        return null;
    return (_jsxs(React.Fragment, { children: ["\u00A0", _jsx("button", { onClick: () => setPriceModalOpen(!isPriceModalOpen), style: {
                    background: 'none',
                    border: 'none',
                    padding: 0,
                    cursor: 'pointer',
                    display: 'inline-flex',
                    alignItems: 'center',
                    color: 'inherit',
                }, "data-testid": 'reference-price-more-info-button', "aria-label": bundle.getMessage('referencePriceInfoButton'), children: _jsx(InfoIcon, { size: 12 }) }), _jsx(Modal, { open: isPriceModalOpen, onClose: () => setPriceModalOpen(false), "data-testid": "reference-price-popoverContent-modal", children: _jsx(RioText, { "data-testid": "reference-price-popoverContent", children: parse(popoverContent) }) })] }));
};
